<template>
    <div>
        <v-text-field @change="find" v-bind:label="'Input molecule\'s '+filter+' pattern'" v-model="input"></v-text-field>
    </div>
</template>

<script>
export default {
    name: "MoleculePattern",
    props: {
        molecules: Array,
        filter: String
    },
    data:
        function() {
            return {
                input: ""
            }
        }
    ,
    methods: {
        findBy(filter, input) {
            let molecules = [];
            switch(filter) {
                case 'name':
                    molecules = this.findByName(input);
                    break;
                case 'formula':
                    molecules = this.findByFormula(input);
                    break;
                case 'SMILES':
                    molecules = this.findBySmiles(input);
                    break;
                case 'InChI':
                    molecules = this.findByInchi(input);
                    break;
            }
            return molecules;
        },
        findBySmiles(input) {
            return this.molecules.filter(molecule => (molecule['smiles'].toUpperCase()).includes(input));
        },
        findByInchi(input) {
            return this.molecules.filter(molecule => (molecule['inchi'].toUpperCase()).includes(input));
        },
        findByName(input) {
            return this.molecules.filter(molecule => (molecule['primaryName'].toUpperCase()).includes(input) || molecule['aliases'].filter(alias => (alias['alias'].toUpperCase().includes(input))).length>0);
        },
        findByFormula(input) {
            return this.molecules.filter(molecule => molecule['molecularFormula'].includes(input) || molecule['formulas'].filter(alias => alias['formula'].toUpperCase().includes(input)).length>0);
        },
        find() {
            this.$emit('get-molecules', this.findBy(this.filter, this.input.toUpperCase()));
        }
    }
}
</script>